import { nsSimCard } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';
import RenderSimOperator from '../components/simOperator/RenderSimOperator';

export default {
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    ORGANIZATION: {
        key: 'organization',
        type: FIELD_TYPES.TEXT,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.organization',
        placeholder: 'sim_pools.filter.placeholder.organization',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    ORGANIZATION_UUID: {
        key: 'organizationUuid',
        type: FIELD_TYPES.TEXT
    },
    TARIFF_DATA: {
        key: 'tariffData',
        type: FIELD_TYPES.NUMBER,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.tariff_data',
        enableSorting: true
    },
    TARIFF_DATA_UNIT: {
        key: 'tariffDataUnit',
        type: FIELD_TYPES.TEXT
    },
    PROVIDER: {
        key: 'simProvider',
        altKey: 'provider',
        type: FIELD_TYPES.COMPONENT,
        component: ({ value }) => {
            return <RenderSimOperator iccidOperators={[value]} textSize='text-sm' />;
        },
        namespace: nsSimCard,
        entity: 'sim_pools.keys.sim_provider',
        placeholder: 'sim_pools.filter.placeholder.provider',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    ACTIVATED_SIMS: {
        key: 'activatedSims',
        type: FIELD_TYPES.NUMBER,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.activated_sims',
        tooltip: 'sim_pools.tooltip.activated_sims',
        enableSorting: true
    },
    MONTH_YEAR: {
        key: 'monthYear'
    },
    TOTAL_ACTIVATED_SIMS: {
        key: 'totalActivatedSims'
    },
    DATA_CONSUMPTION: {
        key: 'dataConsumption',
        type: FIELD_TYPES.NUMBER,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.monthly_consumption',
        tooltip: 'sim_pools.tooltip.monthly_consumption',
        enableSorting: true
    },
    TOTAL_DATA: {
        key: 'totalData',
        type: FIELD_TYPES.NUMBER,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.total_data',
        tooltip: 'sim_pools.tooltip.total_data',
        enableSorting: true
    },
    CONSUMPTION_PERCENTAGE: {
        key: 'consumptionPercentage',
        type: FIELD_TYPES.NUMBER,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.consumption_percentage',
        enableSorting: true
    },
    DATA_USAGE: {
        key: 'dataUsage',
        type: 'chart',
        entity: 'keys.data_usage',
        namespace: nsSimCard,
        placeholder: 'filter.placeholder.data_usage',
        filter: FILTER_TYPES.NUMBER,
        enableSorting: true
    },
    SIM_OFFER: {
        key: 'simOffer',
        type: FIELD_TYPES.OBJECT,
        namespace: nsSimCard,
        entity: 'sim_pools.keys.sim_offer',
        DATA: {
            parentKeys: ['simOffer'],
            key: 'data',
            type: FIELD_TYPES.NUMBER,
            namespace: nsSimCard,
            entity: 'sim_pools.keys.sim_offer.data'
        },
        DATA_UNIT: {
            parentKeys: ['simOffer'],
            key: 'dataUnit',
            type: FIELD_TYPES.TEXT,
            namespace: nsSimCard,
            entity: 'sim_pools.keys.sim_offer.data_unit'
        }
    }

};